import {ClientStatusType} from "./clients.type";
import {ClientLocationsModel} from "../client-locations/client-locations.model";
import {ClientOwnersModel} from "../client-owners/client-owners.model";
import {UsersModel} from "../users/users.model";
import {ProvincesModel} from "../provinces/provinces.model";
import {AreaCodesModel} from "../area-codes/area-codes.model";
import {BaseModel} from '../base/base.model';
export interface IIndustryModel {
    id: number,
    name: number,
}

export interface BusinessAgeModel{
    id: number,
    name: number,
}


export interface IClientModel {
    id?: number,
    lead_id?: number,
    client_name?: string,
    company_name?: string,
    nickname?: string,
    industry?: IIndustryModel,
    industry_id?:number,
    email?: string,
    telephone?: string,
    address?: string,
    business_age_id?: number,
    business_age?: BusinessAgeModel,
    business_age_new?: any,
    avg_monthly_credit?: string,
    financing_required?: string,
    timeframe?: number,
    purpose?: number,
    opener_id?: number,
    closer_id?: number,
    created_at?: string,
    updated_at?: number,
    schedule_time?: string,
    visible?: number,
    status?: ClientStatusType,
    opener?: UsersModel,
    closer?: UsersModel,
    legal_business_name?: string,
    name_of_processors?: string,
    number_of_locations?: number,
    business_fax?: string,
    alternative_phone?: string,
    additional_phone?: string,
    area_code_id?: number,
    area_code?: AreaCodesModel,
    business_location_id?: string,
    mailing_location_id?: string,
    mailing_location?: ClientLocationsModel,
    business_location?: ClientLocationsModel,
    owners?: ClientOwnersModel[],
    notes?:string,
    reason?: number,
    client_type?: string, // standard, cdnpos, inkas, firstdata
    prior_advances?: number, //  0,1,2,3
    stacking?: number, //  0,1
    province_id?: number,
    province?: ProvincesModel,
    percent_of_volume?: number,
    fastcap_type?: string,
    fastcap_only?: boolean,
    business_website_url?: any,
    business_facebook_url?: any
}


export interface ClientsFilter {
    limit?: number,
    page?: number,
    sort?: string,
    order?: string,
    opener_id?: number,
    difference?: string,
    fields?: Array<any>,
    q?: string,
}
export interface ClientScheduleModel {
    schedule_time: string,
    note?: string
}

export interface ClientStatusModel {
    status: number,
    reason?: number
}

export class ClientFundingInformation extends BaseModel{
    last_opportunity_date? = '';
    last_funded_date? = '';
    amount_repaid?: number = 0;
    amount_funded?: number = 0;
    amount_outstanding?: number = 0;
    percentage_paid?: number = 0;
    current_withholding?: number = 0;
    term_days?: number = 0;
    speed_value?: number = 0;
    speed_str? = '';
    number_of_days_since?: number = 0;
    f_13?: number = 0;
    d_13?: number = 0;
    g_13?: number = 0;
    sops? = [];
}

export class FastcapType {
    private static _types = {
        fastcap: 'FastCap',
        synergy: 'Synergy'
    };

    public static getName(key) {
        return FastcapType._types[key];
    }

    public static getOtherName(key) {
        let result = '';
        let ok = false;
        for (let i in FastcapType._types) {
            if (! FastcapType._types.hasOwnProperty(i)) continue;
            if (key != i) result = FastcapType._types[i];
            else ok = true;
        }
        if (ok) return result;
    }

    public static getOtherKey(key) {
        let result = '';
        let ok = false;
        for (let i in FastcapType._types) {
            if (! FastcapType._types.hasOwnProperty(i)) continue;
            if (key != i) result = i;
            else ok = true;
        }
        if (ok) return result;
    }
}

export class ClientTypeModel {
    public types = {
        standard: 'standard',
        inkas: 'inkas',
        cdnpos: 'cdnpos',
        firstdata: 'firstdata',
        eswipe: 'eswipe'
    };
}



// WEBPACK FOOTER //
// ./src/app/models/clients/clients.model.ts